import React from "react"
import Img from "gatsby-image"

const Introduction = ({ intro1, intro2 }) => {
  return (
    <React.Fragment>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <Img
              className="border-rounded"
              fluid={intro2.childImageSharp.fluid}
            />
          </div>
          <div className="col-12 col-md-6">
            <h2 className="text-uppercase">Hi, I'm Ricardo</h2>
            <p>
              Weddings are stressful. I've been there before with my own
              wedding. Family, friends, and all of the planning, it can cause a
              lot of stress. Now throw a camera in your face and I wouldn’t
              blame you for feeling a little awkward. As a wedding photographer
              I work hard to put my clients at ease because let’s be real no one
              photographs well under pressure. I invest time with my clients and
              strive to develop a good relationship all while cracking a joke or
              two to lighten the mood. If all else fails I'll just show you
              pictures of my dogs because who doesn't want to see that.
            </p>
            <p>
              I photograph weddings because I believe relationships of any kind
              matter. The relationships between you and your future spouse, your
              friends, your family, your pet, or whoever it may be. Upon first
              chatting with my couples my goal is to instantly put you at ease
              with my knowledge of the industry, really bad jokes, listening to
              your concerns and of course dog pics. Through my photography I
              give couples a new perspective on their relationship and their
              confidence by making them feel comfortable in front of the camera
              to produce an inviting environment that feels natural. With my
              quirky personality I help break the ice to bring out the real and
              authentic you for everyone to see. So grab your dogs, cats, or
              whatever and let’s chat!
            </p>
            <div className="row justify-content-between">
              <div className="col-12 col-md-6">
                <button className="btn btn-outline-warning w-100" type="button">
                  Read About The Experience
                </button>
              </div>
              <div className="col-12 col-md-6 mt-3 mt-md-0">
                <button
                  className="btn text-white d-block w-100"
                  type="button"
                  style={{
                    background: "rgb(178, 146, 78)",
                    cursor: "pointer",
                  }}
                >
                  Wedding Resources
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Introduction
